import React from "react"
import styled from "styled-components"
import { Container, Table } from "react-bootstrap"

const RatesTable = ({ title, data, cleaningFee }) => {
  return (
    <RatesContainer>
      <h2>{title}</h2>
      <Table bordered hover>
        <thead>
          <tr>
            <th>Dates</th>
            <th>Season</th>
            <th>Price</th>
          </tr>
        </thead>
        {data.map(({ date, season, price }, index) => (
          <tbody key={index}>
            <tr>
              <td>{date}</td>
              <td>{season}</td>
              <td>{price}</td>
            </tr>
          </tbody>
        ))}
      </Table>
      <p>*Cleaning Fee: {cleaningFee}</p>
      <p>5 Nights Minimum Stay in June & September</p>
      <p>7 Nights Minimum Stay in July & August</p>
    </RatesContainer>
  )
}

export default RatesTable

const RatesContainer = styled(Container)`
  color: #fff;
  margin-bottom: 2rem;
  font-family: "Nunito", sans-serif;

  h2 {
    text-align: center;
    margin-bottom: 1rem;
  }
`
